import { createRoot } from 'react-dom/client';
import * as React from 'react';
import SheetDataGrid from './SheetDataGrid';

document.addEventListener('DOMContentLoaded', () => {
  const blocks = document.querySelectorAll('.butler-data-grid');

  blocks.forEach((block) => {
    const scriptUrl = block.dataset.scriptUrl || '';
    const defaultFilter = block.dataset.defaultFilter || '';

    const root = createRoot(block);
    root.render(<SheetDataGrid scriptUrl={scriptUrl} defaultFilter={defaultFilter} />);
  });
});
